import React from "react";
import PanoramaViewer from "./PanoramaViewer";

function App() {
  const params = new URLSearchParams(window.location.search);
  const imageName = params.get("image");
  const imageUrl = imageName ? `/imgs/${imageName}` : null;

  if (!imageUrl) {
    return (
      <div style={styles.placeholder}>
        <h2>🌐 360 Panorama Viewer</h2>
        <p>Pass an image filename as a query parameter to get started:</p>
        <code>?image=sphere.png</code>
        <p style={{ marginTop: "1rem", fontSize: "0.85rem", opacity: 0.6 }}>
          Works with equirectangular (spherical) images.
        </p>
      </div>
    );
  }

  return <PanoramaViewer imageUrl={imageUrl} />;
}

const styles = {
  placeholder: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "100vh",
    gap: "1rem",
    padding: "2rem",
    textAlign: "center",
  },
};

export default App;
